/**
 * Users — the users/{email} doc that powers the dashboard.
 */

import { createUserDoc, type DbResult } from "@travelix/core";

import { displayNameOf, type AuthUser } from "./auth-user";

export { getUserByEmail, repairTripSummaryMiniature } from "@travelix/core";

/**
 * Create (or fill in the stub of) the signed-in user's doc. Safe to call on
 * every sign-in — core no-ops when a registered doc already exists.
 */
export async function ensureUserDoc(user: AuthUser, name?: string): Promise<DbResult<void>> {
  // OAuth providers can technically return a null email; nothing to key on.
  if (!user.email) return { data: undefined, error: null };
  return createUserDoc(user.email, user.uid, name ?? displayNameOf(user));
}
